export const DEPARTMENTS_FETCH_REQUEST = "DEPARTMENTS_FETCH_REQUEST";
export const DEPARTMENTS_FETCH_SUCCESS = "DEPARTMENTS_FETCH_SUCCESS";
export const DEPARTMENTS_FETCH_FAIL = "DEPARTMENTS_FETCH_FAIL";
export const DEPARTMENTS_CLEAR_ERROR = "DEPARTMENTS_CLEAR_ERROR";
